const imageUrl = "https://cdn.cloudflare.steamstatic.com";

export { imageUrl };
